window.onload = function () {
  // Get the current URL
  var currentURL = window.location.href;

  // Define the target substring
  var targetSubstring = '/cart?=edit-delivery';

  // Check if the current URL contains the target substring
  if (currentURL.indexOf(targetSubstring) !== -1) {
    // Perform desired actions if the URL contains the target substring
    console.log("URL contains '/cart?=edit-delivery'");
    theme.promptForDeliveryType();
    updateDeliveryDrawer();
  } else {
    // Perform actions if the URL does not contain the target substring
    console.log("URL does not contain '/cart?=edit-delivery'");
  }
};

let pickingStore = getCookie('picking_store');
let storeName = 'Store not found';

cartDeliveryDetails();

document
  .querySelector('.cart-totals-wrapper')
  .classList.add('loading-delivery');

$('#liquor_receiving').click(function () {
  $('#liquor_receiving_nominate').toggle();
});

$('#leave_unattended').click(function () {
  $("[name='attributes[leave_unattended]']").val(
    $(this).is(':checked') ? 1 : 0
  );
});

$('#no_replacements').click(function () {
  $("[name='attributes[no_replacements]']").val($(this).is(':checked') ? 1 : 0);
});

$('#over_18').click(function () {
  $("[name='attributes[over_18]']").val($(this).is(':checked') ? 1 : 0);
  agileCart.fetchCart();
});

// Show delivery reservation pop-up if sent back from checkout due to Uber address error
let action = new URL(location.href).searchParams.get('action');
if (action == 'uberChooseNewDeliveryType') {
  promptForDeliveryType();
}

$('#liquor_receiving').click(function () {
  $('#liquor_receiving_nominate').toggle();
});

$('#leave_unattended').click(function () {
  $("[name='attributes[leave_unattended]']").val(
    $(this).is(':checked') ? 1 : 0
  );
});

$('#no_replacements').click(function () {
  $("[name='attributes[no_replacements]']").val($(this).is(':checked') ? 1 : 0);
});

function cartDeliveryDetails() {
  if ($.cookie('delivery_expires_time')) {
    //Set order attributes.
    $("input[name='attributes[delivery_date]']").val($.cookie('delivery_date'));
    $("input[name='attributes[delivery_run]']").val($.cookie('delivery_run'));
    $("input[name='attributes[picking_store]']").val($.cookie('picking_store'));
    $("input[name='attributes[courier]']").val($.cookie('delivery_courier'));
    $("input[name='attributes[unique_window]']").val(
      $.cookie('delivery_unique_window')
    );
    $("input[name='attributes[delivery_type]']").val($.cookie('delivery_type'));
    $("input[name='attributes[delivery_cc_store]']").val(
      $.cookie('delivery_cc_store')
    );
    $("input[name='attributes[postcode]']").val($.cookie('postcode'));
    $("input[name='attributes[local_delivery_request]']").val(
      $.cookie('delivery_time')
    );

    if ($.cookie('delivery_type') === 'M') {
      $('#delivery-store strong').html('Click & Collect:');
      $('label[for="over_18"]').html(
        'A person over the age of 18 will be collecting this order and have valid ID.'
      );
    } else if ($.cookie('delivery_type') === 'EX') {
      $('#delivery-store strong').html('Picking Store:');
    }

    //Show delivery reservation details.
    let deliveryDate = new Date($.cookie('delivery_date'));
    let formattedDeliveryDate = deliveryDate.toLocaleDateString('en-AU', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });

    $('#delivery_suburb').html($.cookie('suburb'));
    $('#delivery_date_text').html(formattedDeliveryDate);
    $('#delivery_type_text').html($.cookie('delivery_type_long'));
    $('#delivery_time_text').html($.cookie('delivery_time_short'));

    if (pickingStore) {
      const storeId = parseInt(pickingStore, 10);
      storeName = storeMatrix[0][storeId] || storeName;
    }

    $('#selected_store_text').html(storeName);
    $('#delivery_cart_table').show();

    //Show calculate delivery charge button.
    $('.calc-delivery-charge').show();
  } else {
    // Show please reserve delivery time msg.
    $('#reserve_delivery_msg').show();
    $('#delivery_cart_table').hide();
  }
}
